import React, { useEffect, useState } from 'react';
import { Table } from '@/components/Elements';
import { User } from '@/types';
import TableLoader from '@/components/Elements/Loader/TableLoader';
import { useAgencyRequests } from '@/api/agencyRequests/getAgencyRequests';
import BackdropLoader from '@/components/Elements/Loader/BackdropLoader';
import { Button, MenuItem, MenuList } from '@mui/material';
import i18next from 'i18next';
import chat from '@/assets/chat.svg';
import eye from '@/assets/eye.svg';
import fill from '@/assets/fill.svg';
import view from '@/assets/contract.svg';
import '../routes/Dashboard.css';
import Modal from 'react-responsive-modal';
import close from '@/assets/close-circle.svg';
const ContractList = ({ page, changePage }) => {
  const { data, refetch, isLoading } = useAgencyRequests({ page });
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState('accepted');
  const [open, setOpen] = useState(false);

  const onOpenModal = () => setOpen(true);
  const onCloseModal = () => setOpen(false);

  const handleModal = () => {
    setOpen(false);
    onOpenModal();
  };
  useEffect(() => {
    refetch();
  }, [page, refetch]);

  const staticData = [
    {
      name: 'John Doe',
      mail: 'example12@gmail.com',
      mobile_number: '6578454212',
      property_type: 'Property Project',
      amount: '$200',
      status: 'accepted',
      action: '',
    },
  ];

  const toggleMenu = () => setOpen(!open);
  const handleClose = () => setOpen(false);

  return (
    <>
      <div className='inquiry-filters'>
        <div className='filter-btns-inquiry mb-4 d-flex gap-3 align-items-center'>
          <Button
            className={`inquiry-btn ${activeTab === 'accepted' ? 'active' : ''}`}
            onClick={() => setActiveTab('accepted')}
          >
            Accepted Inquiry
          </Button>
          <Button
            className={`inquiry-btn ${activeTab === 'rejected' ? 'active' : ''}`}
            onClick={() => setActiveTab('rejected')}
          >
            Rejected Inquiry
          </Button>
        </div>
        <div className='admin-cards'>
          <h4 className='f-18 font-semibold mb-0 request-title'>Inquiries</h4>
          <BackdropLoader open={loading} />
          {isLoading ? (
            <TableLoader />
          ) : (
            <Table<User>
              page={1}
              changePage={changePage}
              total={staticData.length}
              data={staticData}
              columns={[
                { title: 'Name', field: 'name' },
                { title: `${i18next.t('Email')}`, field: 'mail' },
                { title: 'Phone number', field: 'mobile_number' },
                { title: `${i18next.t('Property Type')}`, field: 'property_type' },
                { title: `${i18next.t('Bid Amount')}`, field: 'amount' },
                {
                  title: `${i18next.t('Status')}`,
                  field: 'status',
                  Cell: (row) => (
                    <span className="signed-cnt"> 
                     Signed Contract
                    </span> 
                  ),
                },
                {
                  title: 'Action',
                  field: 'action',
                  Cell: () => (
                    <div className='action-filters'>
                      <Button
                        variant='contained'
                        className='bg-transparent border rounded-md px-0 py-2 dropdown-btn shadow-none text-black f-18'
                        onClick={toggleMenu}
                      >
                        <i className='fa-solid fa-ellipsis text-black f-18'></i>
                      </Button>
                      {open && (
                        <div
                          className='open-menu absolute shadow-md p-2'
                          style={{
                            boxShadow: '0px 3.53px 14.11px 0px #00000014',
                            background: '#fff',
                            borderRadius: '10px',
                          }}
                        >
                          <MenuList>
                            <MenuItem className='d-flex align-items-center gap-2'>
                              <img src={eye} className='accept-re' alt='View' /> View Details
                            </MenuItem>
                            <MenuItem className='d-flex align-items-center gap-2'>
                              <img src={chat} className='accept-re' alt='Chat' /> Chat
                            </MenuItem>
                            <MenuItem className='d-flex align-items-center gap-2'  onClick={handleModal}>
                              <img src={view} className='accept-re' alt='View' /> View Sign Contract
                            </MenuItem>
                            <MenuItem className='d-flex align-items-center gap-2' >
                              <img src={fill} className='accept-re' alt='View' /> Fill Form
                            </MenuItem>
                          </MenuList>
                        </div>
                      )}
                    </div>
                  ),
                },
              ]}
            />
          )}
        </div>
        <div className="agency-modal">
        <Modal open={open} onClose={onCloseModal} center>
          <button
            className="modal-close-button"
            onClick={onCloseModal}
            aria-label="Close"
            style={{
              position: 'absolute',
              top: '20px',
              right: '20px',
              background: 'none',
              border: 'none',
              fontSize: '40px',
              cursor: 'pointer',
            }}
          >
            <img src={close} className="close-circle" />
          </button>
          <section className=" agency-model">
            <h5 className="agency-title semi-bold text-black">Contract</h5>
            <div className="conteact-modal m-0" style={{padding: "15px"}}>
              <p className="f-14 my-4">
                Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem
                Ipsum has been the industry's standard dummy text ever since For a limited time
                only, we have managed to secure an income producing six bedrooms HMO within
                proximity to Manchester City Centre. For a limited time only, we have managed to
                secure an income producing six bedrooms HMO within proximity to Manchester City
                Centre.
              </p>
              <p className="f-14 my-4">
                Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem
                Ipsum has been the industry's standard dummy text ever since For a limited time
                only, we have managed to secure an income producing six bedrooms HMO within
                proximity to Manchester City Centre. For a limited time only, we have managed to
                secure an income producing six bedrooms HMO within proximity to Manchester City
                Centre .
              </p>
            </div>
          </section>
          <div className="sub-btns d-flex gap-3 mt-4 align-items-center justify-left">
        
            <Button className="rounded-full pink-btn"> Contract Signature</Button>
          </div>
        </Modal>
      </div>
      </div>
    </>
  );
};

export default ContractList;
